import { useEffect } from "react";
import { useNavigate } from "react-router";

/**
 * Key under which the post-login destination is stashed before a login that
 * involves a full-page round-trip (e.g. Google OAuth). A query param on the
 * login URL cannot survive the round-trip, so we persist it in sessionStorage.
 */
export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

/**
 * Restores the destination the user was headed to before being sent to the
 * login page (typically the OAuth consent screen) after a round-trip login.
 * Call this from authenticated layouts, which only mount once the user is
 * signed in.
 *
 * Email/password logins are redirected synchronously by react-admin and do not
 * set the storage key, so this is a no-op for them.
 */
export function usePostLoginRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    const target = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (!target) return;
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    navigate(target);
  }, [navigate]);
}
